import { FC } from 'react';

import { BlogPostInterface } from '@/src/assets/interfaces/blogPostInterface';

import Wrapper from '../../UI/wrapper/Wrapper';
import { BlogReadNextPost } from '../blogReadNextPost/BlogReadNextPost';

import styles from './BlogReadNext.module.scss';

interface BlogPostReadNextProps {
    posts: BlogPostInterface[];
}

const BlogReadNext: FC<BlogPostReadNextProps> = ({ posts }) => {
    return (
        <Wrapper>
            <div className={styles.readNextSection}>
                <h3 className={styles.readNextTitle}>Read Next</h3>
                <div className={styles.readNextPosts}>
                    {posts.map((post) => {
                        return <BlogReadNextPost key={post._id} post={post} />;
                    })}
                </div>
            </div>
        </Wrapper>
    );
};

export { BlogReadNext };
